import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '@/context/AdminContext';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/SEOHead';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAdmin, isLoading } = useAdmin();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-dark/30 border-t-dark rounded-full animate-spin" />
      </div>
    );
  }

  if (isAdmin) {
    navigate('/admin/portfolio');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/admin/portfolio');
    } else {
      setError(result.error || 'Erro desconhecido');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Acesso Restrito | Jéssica Bonini Fotógrafa"
        description="Painel de gerenciamento do site. Acesso restrito a administradores."
        noindex
      />
      <Navbar />
      <main className="pt-28 md:pt-32 pb-16 md:pb-24 flex items-center justify-center">
        <div className="w-full max-w-sm mx-auto px-6">
          <div className="bg-cream rounded-2xl p-8 md:p-10">
            <div className="text-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-dark text-white mx-auto mb-4">
                <i className="ri-lock-line text-xl" />
              </div>
              <h1 className="font-serif text-2xl text-dark">
                Acesso Restrito
              </h1>
              <p className="text-dark/50 text-sm mt-2">
                Painel de gerenciamento do site
              </p>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div>
                <label htmlFor="admin-email" className="block text-sm font-medium text-dark mb-2">
                  E-mail
                </label>
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-warm-200 bg-white text-dark text-sm focus:outline-none focus:border-dark/40"
                  placeholder="admin@exemplo.com"
                  autoFocus
                  required
                />
              </div>

              <div>
                <label htmlFor="admin-password" className="block text-sm font-medium text-dark mb-2">
                  Senha
                </label>
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-warm-200 bg-white text-dark text-sm focus:outline-none focus:border-dark/40"
                  placeholder="Digite a senha"
                  required
                  minLength={6}
                />
              </div>

              {error && (
                <p className="text-red-600 text-sm bg-red-50 px-3 py-2 rounded-lg">{error}</p>
              )}

              <button
                type="submit"
                disabled={loading || !email || !password}
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-dark text-white text-sm font-semibold hover:bg-dark/90 transition-colors disabled:opacity-50"
              >
                <i className="ri-login-box-line" />
                {loading ? 'Aguarde...' : 'Entrar'}
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}